module.exports = __webpack_public_path__ + "img/3.9ca94cd0.jpg";